import gql from 'graphql-tag';

export const fragments = {
  service: gql`
    fragment PlannedBulletinsTableService on Service {
      plannedBulletins(skip: $skip, limit: $limit) {
        id
        title
        date
      }
    }
  `
};

export default {
  fragments
};
